export function extractPageNameFromUrl(): string {
  const pagename = window.location.pathname.replace(/\//, '');
  return pagename;
}
